export default __webpack_public_path__ + "static/media/ministerio-04-white.4db4c340.svg";